var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2.66669H11.9998C12.3535 2.66669 12.6926 2.80716 12.9426 3.05721C13.1927 3.30726 13.3332 3.6464 13.3332 4.00002V13.3334C13.3332 13.687 13.1927 14.0261 12.9426 14.2762C12.6926 14.5262 12.3535 14.6667 11.9998 14.6667H3.99984C3.64622 14.6667 3.30708 14.5262 3.05703 14.2762C2.80698 14.0261 2.6665 13.687 2.6665 13.3334V4.00002C2.6665 3.6464 2.80698 3.30726 3.05703 3.05721C3.30708 2.80716 3.64622 2.66669 3.99984 2.66669H5.33317",
    stroke: "#93B0C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.33331H6.00016C5.63197 1.33331 5.3335 1.63179 5.3335 1.99998V3.33331C5.3335 3.7015 5.63197 3.99998 6.00016 3.99998H10.0002C10.3684 3.99998 10.6668 3.7015 10.6668 3.33331V1.99998C10.6668 1.63179 10.3684 1.33331 10.0002 1.33331Z",
    stroke: "#93B0C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsSm);
export default __webpack_public_path__ + "static/media/NewsSm.6ffba581027dcfc7e47392501c1c5753.svg";
export { ForwardRef as ReactComponent };